export default __webpack_public_path__ + "static/media/Mortgage_image.7c5c24cf.svg";